import { render } from "./template.2639.vue?vue&type=template&id=6aead66b"
import script from "./template.2639.vue?vue&type=script&lang=js"
export * from "./template.2639.vue?vue&type=script&lang=js"

import "./template.2639.vue?vue&type=style&index=0&id=6aead66b&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__